"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.AvatarGroup = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Avatar_1 = require("./Avatar");
var AvatarGroup_module_scss_1 = __importDefault(require("./AvatarGroup.module.scss"));
var renderCounter = function (remainingAvatars) {
    if (remainingAvatars <= 0)
        return;
    return (react_1["default"].createElement("li", { "aria-label": "There ".concat(remainingAvatars > 1
            ? "are ".concat(remainingAvatars, " other members")
            : "is ".concat(remainingAvatars, " other member"), " of this group"), className: AvatarGroup_module_scss_1["default"].AvatarGroupItem },
        react_1["default"].createElement("span", { className: AvatarGroup_module_scss_1["default"].AvatarCounter, "aria-hidden": true }, "+".concat(remainingAvatars))));
};
var renderAvatars = function (avatars, maxVisible, size) { return (react_1["default"].createElement(react_1["default"].Fragment, null, avatars === null || avatars === void 0 ? void 0 :
    avatars.map(function (avatarProps, index) {
        return index < maxVisible && (react_1["default"].createElement("li", { key: "avatar-".concat(index), className: AvatarGroup_module_scss_1["default"].AvatarGroupItem },
            react_1["default"].createElement(Avatar_1.Avatar, __assign({}, avatarProps, { size: size }))));
    }),
    renderCounter((avatars === null || avatars === void 0 ? void 0 : avatars.length) - maxVisible))); };
/**
 * {@link https://cultureamp.design/components/avatar-group/ Guidance} |
 * {@link https://cultureamp.design/storybook/?path=/docs/components-avatar-avatar-group--default-story Storybook}
 */
var AvatarGroup = function (_a) {
    var _b = _a.size, size = _b === void 0 ? "medium" : _b, _c = _a.maxVisible, maxVisible = _c === void 0 ? 2 : _c, avatars = _a.avatars, classNameOverride = _a.classNameOverride, restProps = __rest(_a, ["size", "maxVisible", "avatars", "classNameOverride"]);
    return (react_1["default"].createElement("ul", __assign({ className: (0, classnames_1["default"])(AvatarGroup_module_scss_1["default"].AvatarGroup, AvatarGroup_module_scss_1["default"][size], classNameOverride), "aria-label": "Avatar Group" }, restProps), renderAvatars(avatars, maxVisible, size)));
};
exports.AvatarGroup = AvatarGroup;
//# sourceMappingURL=AvatarGroup.js.map